<template>
    <div>
        <NavTop/>
        <NavDark/>

        <div class="gray py-3">
            <div class="container">
                <div class="row">
                    <div class="colxl-12 col-lg-12 col-md-12">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link to="#">Home</router-link></li>
                                <li class="breadcrumb-item"><router-link to="#">Pages</router-link></li>
                                <li class="breadcrumb-item active" aria-current="page">Privacy</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <section class="middle">
            <div class="container">
                <div class="row align-items-center justify-content-between">
                    <div class="col-xl-11 col-lg-12 col-md-6 col-sm-12">
                        <div class="abt_caption">
                            <h2 class="ft-medium mb-4">Privacy & Policy</h2>
                            <p class="mb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                            <p class="mb-4">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <FooterTopTwo/>
        <FooterDark/>
        <ScrollToTop/>

    </div>
</template>

<script setup>
    import FooterDark from '@/components/footer/footer-dark.vue';
    import FooterTopTwo from '@/components/footer/footer-top-two.vue';
    import NavDark from '@/components/navbar/nav-dark.vue';
    import NavTop from '@/components/navbar/nav-top.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';
</script>